/* istanbul ignore next */
export function translate(translations, key, options) {
  return applyOptions((translations == null ? void 0 : translations[key]) ?? '', options);
}

/* istanbul ignore next */
function applyOptions(value, options) {
  if (options === void 0) {
    options = /* istanbul ignore next */{};
  }
  return Object.keys(options).reduce((acc, option) => acc.replace(new RegExp(`{{${option}}}`, 'g'), options[option]), value);
}
//# sourceMappingURL=translate.js.map